import { Alert, Box } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import RouteAppShell from '@/common/components/app-shell/RouteAppShell.tsx';

export const Route = createFileRoute('/auth/unauthorized')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RouteAppShell>
      <Box p="sm">
        <Alert color="red" title="Unauthorized">
          Sorry, you don't have access to see this
        </Alert>
      </Box>
    </RouteAppShell>
  );
}
